import * as React from 'react'

export const BackgroundGraphic = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="705.76 0 174.24 328.24"
    height="100%"
  >
    <g clipPath="url(#clip0_24153_2954)">
      <path
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="#8E41E8"
        d="M879 -4.5L879 162.7"
      />
      <path
        strokeMiterlimit={10}
        stroke="#BABEC1"
        d="M713.499 330.308L713.499 164.1L1213.68 164.1L1117.83 311.521C1110.21 323.238 1097.18 330.308 1083.21 330.308L713.499 330.308Z"
      />
      <path
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={2}
        stroke="#8E41E8"
        d="M1022.76 163.6L791.258 163.6"
      />
      <g clipPath="url(#clip1_24153_2954)">
        <path
          strokeMiterlimit={10}
          stroke="#BABEC1"
          d="M771.519 -0.600275L713.02 -0.60028L713.02 89.3784L771.519 -0.600275Z"
        />
        <path
          strokeMiterlimit={10}
          stroke="#BABEC1"
          d="M796.598 205.4C773.513 205.4 754.798 224.114 754.798 247.2C754.798 270.285 773.513 289 796.598 289C819.684 289 838.398 270.286 838.398 247.2C838.398 224.115 819.684 205.4 796.598 205.4Z"
        />
      </g>
      <rect
        stroke="#BABEC1"
        transform="rotate(-180 1548.5 497.5)"
        height={835}
        width={835}
        y={497.5}
        x={1548.5}
      />
    </g>
    <defs>
      <clipPath id="clip0_24153_2954">
        <path
          fill="white"
          d="M0 16C0 7.16345 7.16344 0 16 0H864C872.837 0 880 7.16344 880 16V330H0V16Z"
        />
      </clipPath>
      <clipPath id="clip1_24153_2954">
        <rect
          fill="white"
          transform="rotate(-180 1549 498)"
          height={836}
          width={836}
          y={498}
          x={1549}
        />
      </clipPath>
    </defs>
  </svg>
)
